import { render, staticRenderFns } from "./IdverifyManagement.vue?vue&type=template&id=40df8ad9&"
import script from "./IdverifyManagement.vue?vue&type=script&lang=js&"
export * from "./IdverifyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports